import { Input } from '../../ui';
import { useFieldContext } from '../FieldContext';

/**
 * The native date control on purpose: on a phone it opens the OS date picker,
 * which is faster and more familiar than any calendar we could draw, and it is
 * keyboard-navigable on a desktop.
 */
export function DateInput() {
  const { field, value, onChange, readOnly } = useFieldContext();
  return (
    <Input
      type="date"
      value={typeof value === 'string' ? value.slice(0, 10) : ''}
      onChange={(event) => onChange(event.target.value === '' ? null : event.target.value)}
      disabled={readOnly}
      aria-label={field.label}
    />
  );
}
